export const CLIENT_API_SUBSCRIBE_EMAIL_URL = '/emails/';
